<template>
	<Content :style="{'padding': '10px'}">
	  <Breadcrumb :style="{margin: '5px 0'}">
	    <BreadcrumbItem>素材管理 > <b>添加脚本</b></BreadcrumbItem>
	  </Breadcrumb>
	
	    <Card id="tableContent" >
	      <Form ref="script" :model="script" :rules="ruleValidate"  :label-width="80">
	            <FormItem label="标题" prop="title">
	                <Input v-model="script.title" style="width: 500px" />
	            </FormItem>
				<FormItem label="分类" prop="tag_id">
					<Select v-model="script.tag_id" multiple style="width:260px">
						<Option v-for="item in tags" :value="item.id" :key="item.id">{{ item.tag_name }}</Option>
					</Select>
				</FormItem>
	      		<FormItem label="IP影响力标签" prop="ip_tag_id">
	      			<Select v-model="script.ip_tag_id" multiple style="width:260px">
	      				<Option v-for="item in iptags" :value="item.id" :key="item.id">{{ item.tag_name }}</Option>
	      			</Select>
	      		</FormItem>
	            <FormItem label="内容" prop="content">
	                <Input v-model="script.content" type="textarea" :autosize="{minRows: 10,maxRows: 50}" style="width: 600px" />
	            </FormItem>
	           <FormItem label="素材" prop="mat">
				    <div class="demo-upload-list"  v-for="(item,index) in script.mat">
						<template v-if="item.mat_type == '5'">
							   <img :src="item.mat_url">
						</template>
					   <template v-else>
						   <video width="200" height="200" :src="item.mat_url" controls></video>
					   </template>
					   <div class="demo-upload-list-cover">
						   <span style="color: #fff;font-weight: bold;">{{item.mat_name}}</span>
						   <Icon type="ios-trash-outline" @click.native="handleRemove(index)"></Icon>
					   </div>
				       </div>
	               <Upload :action="getUploadUrl" :headers="uploadHeader" :on-success="successUpload">
	                   <Button icon="ios-cloud-upload-outline">上传图片视频素材</Button>
	               </Upload>
	           </FormItem>  
	            <FormItem>
	                <Button type="primary" @click="updateScript()" >保存</Button>&nbsp;&nbsp;&nbsp;&nbsp;
					 <Button type="primary" @click="back" >返回</Button>
	            </FormItem>
	        </Form>
	    </Card>
	</Content>
  
</template>

<script>
export default {
	data(){
		return {
			iptags:[],
			tags:[],
			script:{
				id:0,
				title:'',
				content:'',
				ip_tag_id:[],
				tag_id:[],
				mat:[]
			},
			ruleValidate: {
				title: [
					{ required: true, message: '标题不能为空', trigger: 'blur' }
				],
				ip_tag_id: [
					{ type: 'array',required: true, message: '请选择标签', trigger: 'blur' }
				],
				// mat: [
				// 	{ type: 'array',required: true, message: '请先上传素材', trigger: 'change' }
				// ],
				content: [
					{ required: true, message: '请输入内容', trigger: 'blur' },
					{ type: 'string', min: 20, message: 'Introduce no less than 20 words', trigger: 'blur' }
				]
			},
			uploadHeader:{
			  "Authorization":localStorage.getItem('token')
			},
		}
	},
	computed:{
		getUploadUrl(){
			return process.env.VUE_APP_APIHOST+'/admin/material/uploadPic';
		}
	},
	mounted(){
		let script_id = this.$route.query.script_id;
		if (typeof(script_id) != 'undefined') {
			this.getScriptInfo(script_id);
		}
		this.getTagList();
		this.getIpTagList();
	},
	methods:{  
		back(){
			this.$router.back();
		},
		getScriptInfo(script_id) {
			this.http.get('/admin/knowledge/scriptInfo',{params:{script_id:script_id}}).then(response=>{
			  let data=response.data;
			  if(data.code!==0){
				alert(data.message);
			  } else{
				  console.log(data.data);
				this.script = data.data;
			  }
			}).catch(()=>{
			  this.$Message.error('网络错误');
			});
		},
	getIpTagList() {
		this.http.get('/admin/common/tagList',{params:{p_tag_id:29}}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.iptags = data.data;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
	getTagList() {
		this.http.get('/admin/common/tagList',{params:{p_tag_id:48}}).then(response=>{
		  let data=response.data;
		  if(data.code!==0){
			alert(data.message);
		  } else{
			this.tags = data.data;
		  }
		}).catch(()=>{
		  this.$Message.error('网络错误');
		});
	},
		updateScript(){
			this.$refs['script'].validate((valid) => {
				if (valid) {
					this.http.post('/admin/knowledge/editScript',this.script).then(response=>{
					  let data=response.data;
					  if(data.code!==0) {
					    this.$Message.error(data.message);
					    return false;
					  } else{
					    this.$Message.info(data.message);
						this.$router.push('/script/scriptList')
					    return true;
					  }
					});
				} else {
					this.$Message.error('Fail!');
				}
			})
			
		},
		handleRemove (index) {
			this.script.mat.splice(index, 1);
		},
		successUpload(response, file, fileList){
			let data=response
			if(data.code!=0){
				this.$Message.error(data.message);
				return true;
			}
			this.script.mat.push(data.data);
			this.$Message.success('上传成功');
		},
	}
}
</script>
<style>
    .demo-upload-list{
        display: inline-block;
        width: 200px;
        height: 200px;
        text-align: center;
        line-height: 200px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .demo-upload-list img{
        width: 100%;
        height: 100%;
    }
    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
		height: 130px;
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
</style>